import { render, staticRenderFns } from "./NoticeBoard.vue?vue&type=template&id=4ffb64a8&scoped=true&"
import script from "./NoticeBoard.vue?vue&type=script&lang=js&"
export * from "./NoticeBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffb64a8",
  null
  
)

export default component.exports